<div class="wrapper">
  <app-resp-popup-title
    i18n="@@FormularEditorBerichtUploadImageProgressPopupTitle"
  >
    Uploading Images
  </app-resp-popup-title>
  <app-resp-popup-content>
    <div class="grid">
      <ng-container #loaderHost></ng-container>
    </div>
  </app-resp-popup-content>
</div>
